import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { getStuffs } from '../../api/Stuffs';
import "../../assets/css/table.css";
import { Spinner } from 'react-bootstrap';

function UserList() {
  const [stuffList, setStuffList] = useState([]);
  const [loading, setLoading] = useState(false);
     
    function getStuffsList(){
       setLoading(true);
       getStuffs((result) =>{
          if(result.ok === 1){
              setStuffList(result.result);
              setLoading(false);
          }
       })  
    }

    

    console.log(stuffList);

  useEffect(()=>{
     getStuffsList();
  }, [])
    return ( 
        <div className='container'>
            <div className='row justify-content-center'>
                <div className='row'>
                    <div className='col md-12'>
                    <div className='row justify-content-center'>
          <div className='row'>
              <div className='col md-6'>
                 <div className='row'>
                  <div className='col md-4'>
                      <div className='form-group'>
                        <label>Search User name</label>
                        <input type="text" placeholder="Type User Name" className='form-control'/>
                      </div>
                  </div>
                  <div className='col md-4'>
                 
                  </div>
                  <div className='col md-4'>
                  
                  </div>
                 </div>
                </div> 
              <div className='col md-6'>
                <Link to="/Add-user" className='btn btn-primary btn-sm float-right'>Add User</Link>
                </div> 
            </div> 
        </div>
            <div className="table-responsive">
              <table className="table align-items-center table-flush table-hover">
                <thead className="thead-light">
                  <tr>
                  <th style={{fontWeight:"bold", color:"#203b56", fontSize:14}}>ID</th>
                <th style={{fontWeight:"bold", color:"#203b56", fontSize:14}}><strong>Name</strong></th>
                <th style={{fontWeight:"bold", color:"#203b56", fontSize:14}}><strong>Departiment</strong></th>
                <th style={{fontWeight:"bold", color:"#203b56", fontSize:14}}><strong>Email</strong></th>
                <th style={{fontWeight:"bold", color:"#203b56", fontSize:14}}><strong>Phone Number</strong></th>
                <th style={{fontWeight:"bold", color:"#203b56", fontSize:14}}><strong>Adress</strong></th>
                <th style={{fontWeight:"bold", color:"#203b56", fontSize:14}}><strong>City</strong></th>
                <th style={{fontWeight:"bold", color:"#203b56", fontSize:14}}><strong>Country</strong></th>
                <th style={{fontWeight:"bold", color:"#203b56", fontSize:14}}><strong></strong></th>
                  </tr>
                </thead>
                {loading ? (
                  <Spinner/>
                ): (
                  <tbody>
                   {stuffList.map((item) =>(
                     <tr>
                     <th style={{fontSize:13}}>{item.id}</th>
                     <td style={{fontSize:16}}><i className='fa fa-user m-2'></i>{item.name}</td>
                      <td style={{fontSize:16}}>{item.departiment}</td>
                      <td style={{fontSize:16}}>{item.email}</td>
                      <td style={{fontSize:16}}>{item.mobile}</td>
                      <td style={{fontSize:16}}>{item.address}</td>
                      <td style={{fontSize:16}}>{item.city}</td>
                      <td style={{fontSize:16}}>{item.country}</td>
                     <td className="text-right">
                       <div className="dropdown">
                         <a className="btn btn-sm btn-icon-only text-light" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                           <i className="fas fa-ellipsis-v " style={{color: "black"}}></i>
                         </a>
                         <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                           <a style={{fontSize:17}} className="dropdown-item" href="#">Edit</a>
                           <a style={{fontSize:17}} className="dropdown-item" href="#">Delete</a>
                           <a style={{fontSize:17}} className="dropdown-item" href="#">View Profile</a>
                         </div>
                       </div>
                     </td>
                   </tr>
                   ))}
                </tbody>
                )}
              </table>
            </div>



                    </div>
                </div>
            </div>
        </div>
     );
}

export default UserList;